import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { HandleClickOutside } from '../../../common/HandleClickOutside'
import UseDevicePixelRatio from '../../../common/hooks/useDevicePixelRatio'
import { Element } from '../../../common/html/element'

export const OpenNewTabComponent = ({
  children,
  style,
  parentRef,
  handleClickOutside,
  x,
  y,
  ...props
}) => {
  const devicePixelRatio = UseDevicePixelRatio()
  const [newTabRefNode, setNewTabRefNode] = useState(null)
  const [isShow, setIsShow] = useState(true)

  const handleAction = () => {
    setIsShow(false)
  }

  useEffect(() => {
    const newTab = document.createElement('div')
    document.body.appendChild(newTab)
    setNewTabRefNode(newTab)

    return () => {
      document.body.removeChild(newTab)
    }
  }, [])

  useEffect(() => {
    setIsShow(true)

    const scrollElement = document.querySelector(
      '#sideBarPortfolio .scrollbars div:first-child',
    )

    scrollElement.addEventListener('scroll', handleAction)
    window.addEventListener('resize', handleAction)
    window.addEventListener('click', handleAction)

    return () => {
      scrollElement.removeEventListener('scroll', handleAction)
      window.removeEventListener('resize', handleAction)
      window.addEventListener('click', handleAction)
    }
  }, [x, y])

  return (
    <>
      {newTabRefNode &&
        isShow &&
        createPortal(
          <HandleClickOutside
            handleClickOutside={handleClickOutside}
            exceptRef={parentRef}
          >
            <Element
              style={{
                ...style,
                top: `${y * devicePixelRatio}px`,
                left: `${x * devicePixelRatio}px`,
                position: 'absolute',
              }}
              onContextMenu={(e) => {
                e.preventDefault()
              }}
              onClick={(e) => {
                e.stopPropagation()
                handleAction()
              }}
              {...props}
            >
              {children}
            </Element>
          </HandleClickOutside>,
          newTabRefNode,
        )}
    </>
  )
}
